<template>
  <div id="header">
    <!-- Start Home Section-->
    <nav class="#e7717d">
      <div class="nav-wrapper header">
        <router-link to="/">
          <img
            src="@/assets/logo-SheImage.png"
            width="60"
            height="40"
            class="brand-logo left logo"
            alt="logo"
            style="
    left: 0px;"
          />
        </router-link>
        <router-link to="/">
          <span class="topic">SheImage Print and Stationery</span></router-link
        >
        <input type="checkbox" id="chk" />
        <label for="chk" class="show-menu-btn">
          <i class="fas fa-bars"></i>
        </label>

        <ul class="menu">
          <router-link to="/">Home</router-link>
          <router-link to="/about">About</router-link>
          <router-link to="/services">Services</router-link>
          <router-link to="/products">Products</router-link>
          <router-link to="/contact">Contact</router-link>
          <label for="chk" class="hide-menu-btn">
            <i class="fas fa-times"></i>
          </label>
        </ul>
      </div>
    </nav>
    <!-- End Home Section-->
  </div>
</template>

<script>
export default {
  name: "Header"
};
</script>

<style scoped>
.header {
  text-align: center;
}

span {
  font-family: sans-serif;
  font-weight: bolder;
  word-spacing: 3px;
  color: black;
  font-size: 20px;
}

.logo {
  margin-top: 13px;
  margin-left: 10px;
}

.menu {
  float: right;
  display: flex;
}

.menu a {
  color: black;
  text-transform: uppercase;
  text-decoration: none;

  font-family: sans-serif;
}

.show-menu-btn,
.hide-menu-btn,
#chk {
  transition: 0.4s;
  visibility: hidden;
}

.show-menu-btn {
  margin-right: 20px;
}

.hide-menu-btn i {
  line-height: 0px;
}

.menu a:hover,
.show-menu-btn:hover,
.hide-menu-btn:hover {
  color: white;
}

.menu a:hover {
  font-weight: 700;
  transform: scale(1.1);
  background: none !important;
}
@media screen and (max-width: 812px) {
  span {
    font-size: 16px;
    padding-left: 55px;
  }

  .show-menu-btn {
    margin-right: 0px;
  }
}

@media screen and (max-width: 786px) {
  .logo {
    margin-top: 13px;
  }

  span {
    font-size: 3.2vw;
  }

  .show-menu-btn,
  .hide-menu-btn {
    display: block;
    visibility: visible;
    color: black;
  }

  .show-menu-btn {
    float: right;
    padding-right: 10px;
  }

  .menu {
    display: block;
    position: fixed;
    width: 30%;
    height: 100vh;
    background: #ee6e73;
    right: -100%;
    top: 0;
    text-align: center;
    padding: 70px 0;
    line-height: normal;
    transition: 0.7s;
    z-index: 2;
  }

  .menu a {
    display: block;
    padding: 20px;
  }

  .hide-menu-btn {
    position: absolute;
    top: 30px;
    right: 20px;
  }

  #chk:checked ~ .menu {
    right: 0;
  }
}
</style>
